module.exports = __webpack_public_path__ + "img/etiqueta-todos.3170eee7.svg";